import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'firstCharacter',
    standalone: false
})
export class FirstCharacter implements PipeTransform {
  transform(value: string): string {
    return value.charAt(0);
  }
}

@Pipe({
    name: 'dateStrFormat',
    standalone: false
})
export class DateStrFormat implements PipeTransform {

  transform(date: string, mask: string, separator?: string): string {

    let out: string = "";

    try {

      if (date != null && date != undefined) {
        let indexesDay = {
          init: 6,
          end: 8
        };

        let indexesMonth = {
          init: 4,
          end: 6
        };

        let indexesYear = {
          init: 0,
          end: 4
        };

        let masks = {
          "DD": function () {
            let day: string = date.substring(indexesDay.init, indexesDay.end);
            return day;
          },
          "MM": function () {
            let month: string = date.substring(indexesMonth.init, indexesMonth.end);
            return month;
          },
          "YYYY": function () {
            let year: string = date.substring(indexesYear.init, indexesYear.end);
            return year;
          },
          "DDMMYYYY": function () {
            let datesData = [this["DD"](), this["MM"](), this["YYYY"]()];
            return datesData.join(separator);
          }
        }
        out = masks[mask]();
      } else {
        out = out.concat("-");
      }
      return out;
    } catch (err) {
      return null;
    }

  }

}